import { render, staticRenderFns } from "./FilesListHeader.vue?vue&type=template&id=272fbca3"
import script from "./FilesListHeader.vue?vue&type=script&lang=ts"
export * from "./FilesListHeader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports